/* eslint-disable @typescript-eslint/no-explicit-any */
import SearchInsights from 'search-insights';
import { CONFIG } from '../../config';

let isInitialized = false;

export const initializeInsights = () => {
  if (!isInitialized) {
    SearchInsights('init', {
      appId: CONFIG.ALGOLIA_APPLICATION_ID,
      apiKey: CONFIG.ALGOLIA_API_KEY
    });
    isInitialized = true;
  }
};

/**
 * Consent-aware wrapper for Algolia Search Insights.
 * Only forwards tracking calls if user has given consent (initializeInsights was called).
 * Safe to call throughout the app even without consent.
 */
export const ConsentAwareSearchInsights = (method: string, ...args: any[]) => {
  if (!isInitialized) {
    return;
  }

  return (SearchInsights as any)(method, ...args);
};

export { SearchInsights };
export default ConsentAwareSearchInsights;
